import { Controller } from '@hotwired/stimulus'
import { hideElement, showElement } from 'utils/toggle_element_visibility'
import AJAX from 'utils/ajax'

export default class extends Controller {
  static targets = ["addButton", "submitButton", "body", "row", "rowEditable", "emptyRow", "form", "successAlert", "dropdown", "removeEmptyButton"]
  initialize() {
    this.insertionTemplate = this.addButtonTarget.getAttribute("data-association-insertion-template")

    this.newRowCount = 0
    this.notRequiredList = JSON.parse(this.formTarget.dataset.notRequiredList || "[]")

    this._updateInsertionTemplate(null)

    this._disableAddCasebookSubjectScrollTop()
  }

  submitCasebookSubjects(event) {
    // Wait a bit until DOM is updated after removal
    setTimeout(() => {
      this._disableActions()
      this._toggleActions() // Re-enable Add button after removing editable fields
    }, 500)
  }

  removeCasebookSubject(_event) {
    // Display empty panel when no more rows
    // Length <= 1 used since DOM isn't updated yet so the last known available row target is 1
    // Disable submit button since nothing to submit with empty row
    if ((this.rowTargets.length + this.rowEditableTargets.length) <= 1) {
      showElement(this.emptyRowTarget)
      this.submitButtonTarget.setAttribute("disabled", true)
    }
  }

  removeEmptyCasebookSubject(event) {
    // Params unable to be retrieved and keep returning undefined so need to manually retrieve casebookSubjectId
    const casebookSubjectId = event.currentTarget.getAttribute("data-item-casebook-subject-id-param")
    let newRow = null

    if (casebookSubjectId === "" || casebookSubjectId === null) {
      newRow = document.querySelector("[data-manage-casebook-subject-row='']")
    } else {
      newRow = document.querySelector(`[data-manage-casebook-subject-row='new-row-${casebookSubjectId}']`)
    }

    if (newRow !== null) {
      newRow.remove()
    }

    // Display empty panel when no more rows
    if (this.rowTargets.length === 0 && this.rowEditableTargets.length === 0) {
      showElement(this.emptyRowTarget)
    }

    // Wait a bit until DOM is updated after removal
    setTimeout(this._disableActions(), 500)
    this._toggleActions() // Re-enable Add button after removing editable fields
  }

  handleAddRowButton(event) {
    // Disallow add row button to fire cocoon events when disabled
    if (event.target.getAttribute("disabled") === "true") {
      event.stopPropagation()
    }

    hideElement(this.emptyRowTarget)
  }

  addCasebookSubject(_event) {
    this._updateInsertionTemplate(this.newRowCount - 1)
    this._disableActions()
  }

  editCasebookSubject(_event) {
    // Reable submit button if no other submittable rows to complete
    if (this.rowEditableTargets.length === 0) {
      this.submitButtonTarget.removeAttribute("disabled")
    }
  }

  detectInputChange(event) {
    this._toggleActions()
  }

  disableAll() {
    this.addButtonTarget.setAttribute("disabled", true)
    this.submitButtonTarget.setAttribute("disabled", true)
  }

  _disableActions() {
    if (this.rowEditableTargets.length > 0) {
      this.addButtonTarget.setAttribute("disabled", true)
    }

    this.submitButtonTarget.setAttribute("disabled", true)
  }

  _enableActions() {
    this.addButtonTarget.removeAttribute("disabled")

    if (this.dropdownTargets.length > 0) {
      this.submitButtonTarget.removeAttribute("disabled")
    }
  }

  _updateInsertionTemplate(id) {
    let insertionTemplate = this.insertionTemplate

    if (id === null) {
      insertionTemplate = insertionTemplate.replaceAll(`data-manage-casebook-subject-row=""`, `data-manage-casebook-subject-row="new-row-${this.newRowCount}"`)
      insertionTemplate = insertionTemplate.replaceAll(`data-item-casebook-subject-id-param=""`, `data-item-casebook-subject-id-param="${this.newRowCount}"`)
    } else {
      insertionTemplate = insertionTemplate.replaceAll(`data-manage-casebook-subject-row="new-row-${id}"`, `data-manage-casebook-subject-row="new-row-${this.newRowCount}"`)
      insertionTemplate = insertionTemplate.replaceAll(`data-item-casebook-subject-id-param="${id}"`, `data-item-casebook-subject-id-param="${this.newRowCount}"`)
    }

    this.insertionTemplate = insertionTemplate
    this.addButtonTarget.setAttribute("data-association-insertion-template", this.insertionTemplate)

    this.newRowCount += 1
  }

  _toggleActions() {
    // Enable Add and Submit button if all fields filled out
    this._enableActions()
    this._toggleAction(this.dropdownTargets)
  }

  _toggleAction(inputs) {
    inputs.forEach((input) => {
      if (input.dataset.required === "true" || this._isRequired(this._casebookSubjectFor(input))) {
        input.removeAttribute("disabled")
        if (input.value === "" || input.value === null) {
          this._disableActions()
        }
      } else {
        input.value = null
        input.setAttribute("disabled", "disabled")
      }
    })
  }

  // Disables cocoon href="#" default scroll to top when disable for Add casebook subject button
  // https://stackoverflow.com/a/21717034
  _disableAddCasebookSubjectScrollTop() {
    this.addButtonTarget.setAttribute("href", "#/")
  }

  _isRequired(id) {
    // Is not in the not-required list
    return this.notRequiredList.indexOf(id) === -1
  }

  _casebookSubjectFor(input) {
    return parseInt(input.closest("[data-manage-casebook-subject-row]").querySelector("select[data-casebook-subject-field]").value)
  }
}
